import imageResolutionConfirmation from 'emun.on-demand/confirmations/image-resolution-confirmation'
import emptyDesignConfirmation from 'emun.on-demand/confirmations/empty-design-confirmation'
import outOfBoundsConfirmation from 'emun.on-demand/confirmations/out-of-bounds-confirmation'

let config = {
    confirmations: [
        emptyDesignConfirmation,
        imageResolutionConfirmation,
        outOfBoundsConfirmation,
    ],
    mediaFilters: [
        { tag: "Art Category" },
        { tag: "Art Name" },
        { tag: "Category" },
        { tag: "Graphic" }]
};

export default config